import { clientConstants as constants } from '../_constants/client.constants';

export const clientActions = {
  setAccount,
  setServices,
  setUsersOnline,
  addUserOnline,
  removeUserOnline
}

function removeUserOnline(userId) {
  return { type: constants.CLIENT_REMOVE_USER_ONLINE, userId }
}

function addUserOnline (user) {
  return { type: constants.CLIENT_ADD_USER_ONLINE, user }
}

function setUsersOnline(currentUserId, members) {
  const users = Object.keys(members)
    .filter(memberId => {
      return parseInt(memberId) !== parseInt(currentUserId)
    })
    .map(key => {
      return {
        ...members[key],
        typing: false
      }
    })

  return { type: constants.CLIENT_SET_USERS_ONLINE, users }
}

function setAccount(account) {
  return { type: constants.SET_ACCOUNT, account }
}

function setServices(services) {
  return { type: constants.SET_SERVICES, services }
}